import * as React from 'react';
import { observer } from 'mobx-react';

import { IMtsTicketStore, ITodayTicketsStore, ICashOutListStore, CouponTabsType as RightColumnTicketWrapperAreaTabsType, TicketStatusType, OfferType } from 'eTip--common';
import { TicketContainer } from './ticketContainer';
import { OTBTicketContainer } from './otbTicketContainer';
import { TodayTicketsContainer } from './../todayTicketsContainer/todayTicketsContainer';

import { CashOutTickets } from 'common--design-library';
import { TicketWrapperTabs, DesktopTicketsWrapper, OTBSwitch } from 'desktop--design-library';

import { translationForMts } from 'easit--localization';

export interface IRightColumnTicketAreaWrapperProps {
    ticketWrapper: IMtsTicketStore;
    todayTickets: ITodayTicketsStore;
    cashOutList: ICashOutListStore;
    isLive: boolean;
    reloadCashoutOnError: () => void;
    goToEventDetail: (eventId: number, offerType: OfferType) => void;
    goToTicketDetail: (ticketId: string) => void;
}

@observer
export class RightColumnTicketAreaWrapper extends React.Component<IRightColumnTicketAreaWrapperProps, { selectedTab: RightColumnTicketWrapperAreaTabsType }> {

    constructor(props: IRightColumnTicketAreaWrapperProps) {
        super(props);
        this.state = { selectedTab: RightColumnTicketWrapperAreaTabsType.Ticket };
    }

    private reloadTimer: number;

    componentDidMount() {
        this.reloadTimer = window.setInterval(() => {
            this.props.ticketWrapper.timerReload();
        }, 3000);
    }

    componentWillUnmount() {
        window.clearInterval(this.reloadTimer);
    }

    setSelectedTab(tab: RightColumnTicketWrapperAreaTabsType) {
        this.setState({ selectedTab: tab });
    };

    render() {
        const selectedTicket = this.props.ticketWrapper.tickets[this.props.ticketWrapper.activeTicketIndex];
        return <React.Fragment>
            <div className="ticket-main-wrapper">
                {!selectedTicket.isOTBSettingSet && <TicketWrapperTabs
                    selectedTab={this.state.selectedTab}
                    onTabChange={(tab) => { this.setSelectedTab(tab); }}
                    itemCounts={this.props.cashOutList.isAvailable
                        ? /* TODO overcomplicated and always new value */ new Map<RightColumnTicketWrapperAreaTabsType, number>([
                            [RightColumnTicketWrapperAreaTabsType.CashOut, this.props.cashOutList.bets.length]]) :
                        new Map<RightColumnTicketWrapperAreaTabsType, number>()}
                />}
                {
                    this.state.selectedTab === RightColumnTicketWrapperAreaTabsType.Ticket &&
                    <>
                        {
                            this.props.ticketWrapper.canShowOneTapBet && selectedTicket.isLoggedUser &&
                            <OTBSwitch isOTBOn={this.props.ticketWrapper.isOTB}
                                isOTBActive={selectedTicket.isOTBSettingSet}
                                switchColor={this.props.ticketWrapper.isOTB && selectedTicket.isOTBSettingSet ? selectedTicket.template.otbActiveSwitchColor : (__IsMTSTipos__ ? "#c47621" : "#F59429" /* TODO experimental ... */)}
                                toggleOTB={(isOn) => { this.props.ticketWrapper.setIsOTB(isOn); }}
                            />
                        }
                        {
                            this.props.ticketWrapper.isOTB
                                ? <OTBTicketContainer
                                    ticket={selectedTicket}
                                    toggleOTB={(isOTBOn: boolean) => { this.props.ticketWrapper.setIsOTB(isOTBOn); }}
                                />
                                : <>
                                    {
                                        this.props.ticketWrapper.tipsCount > 0
                                            || selectedTicket.ticketState === TicketStatusType.Saved
                                            || selectedTicket.ticketState === TicketStatusType.Accepted
                                            ? <DesktopTicketsWrapper
                                                isLive={this.props.isLive}
                                                tickets={this.props.ticketWrapper}
                                                selectedTab={this.props.ticketWrapper.activeTicketIndex}
                                                isCouponCopyVisible={true}
                                                copyCoupon={() => { this.props.ticketWrapper.copyTicketTab() }}
                                                clearCoupon={() => { this.props.ticketWrapper.clearCouponAsync() }}
                                                prepareCouponCopy={() => { }}
                                                onTabChange={(index: number) => {
                                                    this.props.ticketWrapper.setActiveCoupon(index)
                                                }}
                                                ticketContainer={<TicketContainer
                                                    ticket={selectedTicket}
                                                    clearCoupon={() => { this.props.ticketWrapper.clearCouponAsync() }}
                                                    goToEventDetail={this.props.goToEventDetail}
                                                    roleForTest="ticket__tabs_item"
                                                />}
                                            />
                                            : <div className="p-2">{translationForMts().ticket_NoTips}</div>
                                    }
                                </>
                        }
                    </>
                }
                {
                    this.state.selectedTab === RightColumnTicketWrapperAreaTabsType.CashOut &&
                    <CashOutTickets
                        goToDetail={(ticketId: number) => { this.props.goToTicketDetail(ticketId.toString()); }}
                        cashoutStore={this.props.cashOutList}
                        reloadOnError={() => { this.props.reloadCashoutOnError(); }}
                    />
                }
            </div>
            {
                <TodayTicketsContainer
                    todayTickets={this.props.todayTickets}
                    cashOutList={[...this.props.cashOutList.bets.map(item => { return { id: item.betId, value: item.cashOut } })]}
                    goToTicketDetail={this.props.goToTicketDetail}
                />
            }

        </React.Fragment >
    }
};
